import { memo, useMemo } from 'react';
import { RouteLoader } from '@dfl/react-security';
import { getRoutes } from './main.routes';
import { BreadcrumbsProvider } from '@dfl/mui-admin-layout';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CurrentBusinessContextProvider } from 'modules/security/spaces/contexts/CurrentBusinessContext';
import { useLocation } from 'react-router-dom';
import { REDIRECT_KEY } from 'constants/index';
import { useAuthFromPortal } from 'hooks/useAuthFromPortal';

const Routes = () => {
  const { pathname } = useLocation();

  useAuthFromPortal();

  const redirectUrl = useMemo(() => {
    if (pathname === '/') {
      return '/auth/login';
    }
    return `/auth/login?${REDIRECT_KEY}=${encodeURIComponent(pathname)}`;
  }, [pathname]);

  return (
    <CurrentBusinessContextProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BreadcrumbsProvider>
          <RouteLoader routes={getRoutes(redirectUrl)} />
        </BreadcrumbsProvider>
      </LocalizationProvider>
    </CurrentBusinessContextProvider>
  );
};

export default memo(Routes);
